import { Supplier } from "./supplier";
import { SupplierClassification } from "./supplier-classification";

export class SupplierClassificationAssignmentId {
  supplierId?: number;
  supplierClassificationId?: number;
}
export class SupplierClassificationAssignment {
  id: SupplierClassificationAssignmentId = new SupplierClassificationAssignmentId();
  supplier?: Supplier;
  supplierClassification?: SupplierClassification = new SupplierClassification();
}
